export const MuiTypography = {
  defaultProps: {
    variantMapping: {
      h1Bold: 'h1',
      h2Bold: 'h2',
      h3Bold: 'h3',
      h4Bold: 'h4',
      h5Bold: 'h5',
    },
  },
};
